<template>
  <v-flex>
    <v-toolbar color="secondary" dense>
      <v-toolbar-title class="primarytext--text">Richieste</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-tabs v-model="tabs" centered color="primary" dark icons-and-text grow>
      <v-tabs-slider color="secondary"></v-tabs-slider>

      <v-tab href="#richieste" :key="1">
        <v-card-text style="color:black">IN ARRIVO</v-card-text>
      </v-tab>

      <v-tab href="#storico" :key="2">
        <v-card-text style="color:black">STORICO</v-card-text>
      </v-tab>

      <v-tabs-items v-model="tabs">
        <v-tab-item value="richieste" :key="1">
          <v-card flat v-if="tabs === 'richieste'">
            <TabRichieste :richiesteInSospeso="richiesteInSospeso" :categorie="categorie"></TabRichieste>
          </v-card>
        </v-tab-item>
        <v-tab-item value="storico" :key="2">
          <v-card flat v-if="tabs === 'storico'">
            <TabStorico
              :richiesteVerificate="richiesteVerificate"
              :dialog="dialog"
              @onClose="dialog = false"
            ></TabStorico>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-flex>
</template>

<script>
import TabRichieste from "./TabRichieste.vue";
import TabStorico from "./TabStorico.vue";

export default {
  name: "richieste",
  components: { TabStorico, TabRichieste },
  props: {},
  data() {
    return {
      tabs: "richieste",
      dialog: false
    };
  },
  computed: {
    categorie() {
      return this.$store.getters.getPageData.categorieSpese;
    },
    preautorizzati() {
      return this.$store.getters["gestione/preautorizzati"];
    },
    richieste() {
      return this.$store.getters["gestione/richieste"];
    },
    richiesteInSospeso() {
      return this.richieste
        .filter(it => it.stato == 0)
        .map(it => {
          return it;
        });
    },
    richiesteVerificate() {
      return this.richieste
        .filter(it => it.stato == 1 || it.stato == 2)
        .map(it => {
          return it;
        });
    }
  },
  created() {
  },
  beforeCreate() {
    if (!this.$store.hasModule("gestione")) {
      this.$store.registerModule("gestione", GestioneAdmin);
    }
  },
  methods: {}
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/Richieste.vue